import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import { gsap, ScrollTrigger } from "gsap/all"
import { isTablet } from "react-device-detect"
import TransitionLink from "gatsby-plugin-transition-link"

import { ALIGN } from "../contentful/globals"
import Menu from "../global/menu"
import FullScreenPlayer from "../atomic/organisms/FullScreenPlayer"

export const ContainerContext = React.createContext()

export default class Container extends React.Component {
  state = {
    mode: "portrait",
    logoColor: "white",
    video: null,
  }

  constructor(props) {
    super(props)
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(ScrollTrigger)
      gsap.core.globals("ScrollTrigger", ScrollTrigger)
    }
  }

  componentDidMount() {
    const _this = this

    if (this.props.direction === ALIGN.HORIZONTAL)
      window.onresize = _this.onResize

    if (isTablet) {
      let container = document.getElementById("container")
      container.style.overflowX = "scroll"
      container.style.overflowY = "hidden"
    }

    if (this.props.direction === ALIGN.HORIZONTAL)
      setTimeout(() => this.onResize(), 800)

  }

  playVideo(url) {
    this.setState({ video: url })
  }

  onResize = () => {
    if (window.innerWidth > window.innerHeight) {
      if (this.state.mode !== "landscape" && !isTablet)
        this.setState({ mode: "landscape" }, () => {
          this.initialiseHorizontalScroll()
        })
    } else {
      if (this.state.mode !== "portrait")
        this.setState({ mode: "portrait" }, () => {
          this.disableHorizontalScroll()
          console.log(this.state.mode)
        })
    }
  }

  onAnchor = id => {
    console.log(`We should go to ${id}.`)
  }

  initialiseHorizontalScroll = () => {
    let container = document.getElementById("container")

    gsap.to(container, {
      x: () => - (container.scrollWidth - document.documentElement.clientWidth) + "px",
      ease: "none",
      scrollTrigger: {
        trigger: container,
        invalidateOnRefresh: true,
        pin: true,
        scrub: 1,
        end: () => "+=" + container.offsetWidth,
      },
      onUpdate:() => this.observeScroll()
    })
  }

  disableHorizontalScroll = () => {
    let container = document.getElementById("container")
    gsap.killTweensOf(container)
    ScrollTrigger.getAll().forEach(st => st.kill())
  }

  observeScroll() {
    const transformStyle = document.getElementById('container').style.transform
  }

  render() {
    const { direction, transition } = this.props

    return (
      <ContainerContext.Provider
        value={{
          navigateTo: id => this.onAnchor(id),
          changeTheme: color => {
            this.setState({ logoColor: color }, () => console.log(this.state.logoColor))
          },
          playVideo: url => this.playVideo(url),
        }}
      >
        {this.state.video && (
          <FullScreenPlayer
            url={this.state.video}
            onEnd={() => this.setState({ video: null })}
          />
        )}
        <Menu transition={transition} />

        {direction === ALIGN.HORIZONTAL && (
          <HorizontalWrap id="container">{this.props.children}</HorizontalWrap>
        )}

        {direction === ALIGN.VERTICAL && (
          <VerticalWrap id="container">{this.props.children}</VerticalWrap>
        )}
      </ContainerContext.Provider>
    )
  }
}

const HorizontalWrap = styled.div`
  overflow: none;
  display: flex;
  flex-direction: column;

  ${up("md")} {
    flex-wrap: wrap;
    flex-direction: column;
    height: 100vh;
  }
`

const VerticalWrap = styled.div`
  background-color:white;
  ${up("lg")} {
  }
` 
